module.exports = __webpack_public_path__ + "static/media/leftPointer.bf31db4f.svg";